import { i18n } from '@/i18n';
import { cookies } from '@/plugins/cookies';

export const localGuard = (to, from, next) => {
  if (to.meta.disableLangSwitch) {
    i18n.locale = i18n.fallbackLocale;
  }

  cookies.set('language', to.query.language);

  next();
};
